/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Maxim Fedorov
 * @version 1.1.0
 * @since 1.1.0
 */

import { ComponentType } from 'react';

interface IWithStatusesProps {
    isLoading: boolean;
    isError: boolean;
    isEmpty: boolean;
}

export function withStatuses<LP, ErP, EmP>(LoadingComponent: ComponentType<LP>, loadingProps?: LP) {
    return function (ErrorComponent: ComponentType<ErP>, errorProps?: ErP) {
        return function (EmptyComponent: ComponentType<EmP>, emptyProps?: EmP) {
            return function <WP extends IWithStatusesProps>(WrapperComponent: ComponentType<WP>): ComponentType<WP> {
                return (wrapperProps: WP) => wrapperProps.isLoading
                    // @ts-ignore
                    ? <LoadingComponent {...wrapperProps} {...loadingProps}/>
                    : wrapperProps.isError
                        // @ts-ignore
                        ? <ErrorComponent {...wrapperProps} {...errorProps}/>
                        : wrapperProps.isEmpty
                            // @ts-ignore
                            ? <EmptyComponent {...wrapperProps} {...emptyProps} />
                            : <WrapperComponent {...wrapperProps} />;
            };
        };
    };
}
